export default {
  getAssets: state => state.assets || [],
  getCurrentAssetIdInDB: state => state.currentAssetIdInDB || {},
};
